<template>
  <div class="cart-view">
    <div class="grid-row">
      <div class="c-12 c-xs-12 c-sm-12 c-md-12 c-lg-12">
        <CartStepper />
      </div>
    </div>
    <div class="grid-row">
      <div class="c-12">
        <h1>{{$_('select_your_delivery_address')}}</h1>
      </div>
    </div>
    <div class="grid-row">
      <div class="c-9 c-xs-12 c-sm-12 c-md-12 c-lg-9">
        <CustomerAddress :pnocl="pnocl" />
      </div>
      <div class="c-3 c-xs-12 c-sm-12 c-md-12 c-lg-3">
        <CartSummary :step="'cartdelivery'" :next_step="'cartpayment'" />
      </div>
    </div>
  </div>
</template>

<script>

import CartSummary from '@/modules/panier/components/CartSummary';
import CartStepper from '@/modules/panier/components/CartStepper';
import CustomerAddress from '@/modules/client/components/CustomerAddress';

export default {
  name: 'Delivery',
  data() {
    return {
      pnocl: this.$store.getters['application/get_application_customer'].TNCLI
    }    
  },
  components: {
    CartSummary,
    CartStepper,
    CustomerAddress
  }
}
</script>

<style scoped>
.cart-view {
  padding: 15px;
}
</style>